// The participant count cannot identify a direct conversation: a working group
// or an event may temporarily contain just two people.
export const isDirectChat = chat => chat?.type_chat === 'direct' || chat?.is_dm === true;

export const chatKindLabel = chat => isDirectChat(chat)
  ? 'ЛС · Личный диалог'
  : chat?.event_id || chat?.type_chat === 'event'
    ? 'Чат события'
    : 'Группа';
